module.exports = __webpack_public_path__ + "static/media/verification_suite.fdadcd36.svg";